module.exports = "https://dev.stanwinstonschool.com/smallsoldiers_poster_alt.a7c97b9e90665342ac5435faf1c0ad72.jpg";